import { baseApi } from "@dex/bubl-fetch";

const endpoint = 'LeagueSeasonDivision';

const LeagueSeasonDivisionApi: any = baseApi(endpoint);

export default LeagueSeasonDivisionApi;